import { render, staticRenderFns } from "./VipForWps.vue?vue&type=template&id=51d29311&scoped=true"
import script from "./VipForWps.vue?vue&type=script&lang=js"
export * from "./VipForWps.vue?vue&type=script&lang=js"
import style0 from "./VipForWps.vue?vue&type=style&index=0&id=51d29311&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d29311",
  null
  
)

export default component.exports